import { useTranslation } from "react-i18next";
import { Form, Grid, Icon } from "semantic-ui-react";

import { createFormHelper } from "lib/Form";
import { NOTIFICATION_ENTITY_TEMPLATE } from "models";
import { useNotificationElements } from "modules/AccountSettings/components/NotificationsSection/hooks";

import type { User } from "models";
import type { ReactElement } from "react";

const FormHelper =
  createFormHelper<
    Pick<User, "notification_element_ids" | "pin_status_notification_enabled" | "customer_waiting_car_in_shop_notification_enabled" | "is_desktop_notifications_enabled">
  >();

export const NotificationsSection = () => {
  const { t } = useTranslation();

  const { setValue, watch } = FormHelper.useFormContext();
  const { groupedNotificationElements } = useNotificationElements();
  const notificationElementIds = watch("notification_element_ids") || [];

  const handleChangeNotificationsCheckbox = (notificationElementId: number) => {
    const idx = notificationElementIds.findIndex(el => el === notificationElementId);
    setValue(
      "notification_element_ids",
      idx > -1 ? notificationElementIds.filter(el => el !== notificationElementId) : [...notificationElementIds, notificationElementId]
    );
  };

  const getDesktopNotificationsFormFields = () => {
    const fields: ReactElement[] = [];

    // TODO: this is bad, we control the type of groupedNotificationElements, so we can avoid doing an Object.xxx on it
    // Also this clearly require adding a FormHelper.Field.ArrayCheckbox to not have to use semantic Form.Field+Checkbox here
    Object.entries(groupedNotificationElements).forEach(([entityId, entity]) => {
      const uiElements: ReactElement[] = [];

      entity.elements.forEach(el =>
        uiElements.push(
          <Form.Field key={el.notification_element_id}>
            <Form.Checkbox
              key={el.notification_element_id}
              checked={notificationElementIds.includes(el.notification_element_id)}
              onChange={() => handleChangeNotificationsCheckbox(el.notification_element_id)}
              label={
                <label>
                  <div className="circular-icon">
                    <Icon className={el.field?.icon} />
                    {el.field?.sub_icon && <Icon className={`${el.field.sub_icon} small subIcon`} />}
                  </div>
                  <p>{el.field && t(el.field.name, el.field.name)}</p>
                </label>
              }
            />
          </Form.Field>
        )
      );

      // TODO: WTF is happening here, this logic is dirty as fuck, how is nobody standing up about this ?!
      // we have template to know how to display things, and here we hardcode showing extra hardcoded checkbox based on a template value ?!
      // and we show checkboxes for all templates ?! dropdown multi is now showing checkboxes yet nobody care to bring this up ?!
      if (entity.templateId === NOTIFICATION_ENTITY_TEMPLATE.CheckBoxes) {
        uiElements.push(
          <FormHelper.Field.Checkbox
            key={"pin_status_notification_enabled"}
            name="pin_status_notification_enabled"
            label={
              <label>
                <div className="circular-icon">
                  <Icon name="pin" />
                </div>
                <p>{t("v8_pin_status_notifications", "Pin status notifications")}</p>
              </label>
            }
          />
        );

        uiElements.push(
          <FormHelper.Field.Checkbox
            key={"customer_waiting_car_in_shop_notification_enabled"}
            name="customer_waiting_car_in_shop_notification_enabled"
            label={
              <label>
                <div className="circular-icon customer-waiting-car-in-shop-notification-setting">
                  <Icon className="car garage garage-icon" />
                  <Icon className="user customer-icon" />
                </div>
                <p>{t("v8_waiting_customer_car_in_shop", "Waiting customer Car in shop")}</p>
              </label>
            }
          />
        );
      }

      fields.push(
        <Grid.Column width={entity.title === "v8_notification_entity_appointment" ? 6 : 10} key={entityId}>
          <div className="DesktopNotifications">
            <h4>{t(entity.title, entity.title)}</h4>
            <Form.Group grouped className={entity.title === "v8_notification_entity_appointment" ? undefined : "two-columns"}>
              {uiElements}
            </Form.Group>
          </div>
        </Grid.Column>
      );
    });

    return fields;
  };

  return (
    <section id="account-settings-notifications-section">
      <div className="setting_section">
        <h3 className="section-title">{t("v8_notifications", "Notifications")}</h3>
        <p className="section-subtitle ">{t("v8_adjust_behaviour_of_notifications_here", "You can adjust behaviour of notifications here")}</p>
        <h3 className="section-title">{t("v8_desktop_notifications", "Desktop Notifications")}</h3>
        <FormHelper.Field.Checkbox
          name="is_desktop_notifications_enabled"
          label={t("v8_get_a_desktop_notification", "Get a notification on your desktop when you receive a notification in Claire")}
        />
        <h3 className="section-title">{t("v8_claire_notifications", "Claire Notifications")}</h3>
        <Grid>
          <Grid.Row className="DesktopNotifications-row">{getDesktopNotificationsFormFields()}</Grid.Row>
        </Grid>
      </div>
    </section>
  );
};
